import React, { useCallback } from "react";
import { useGlobalState } from "@/hooks/useGlobalState";
import { getBrowserMicPermission } from "./utils/get-browser-mic-permission";
import widgetIcon from "/images/widget-icon.webp";

interface Step1Props {
  setStep: (step: number) => void;
}

const Step1: React.FC<Step1Props> = ({ setStep }) => {
  const { setChatMode, setMicPermission } = useGlobalState();

  const handleChooseChatMode = useCallback(
    async (mode: "voice" | "text") => {
      setChatMode(mode);
      setStep(2);

      setMicPermission(await getBrowserMicPermission());
    },
    [setChatMode, setStep],
  );

  const handleChooseVoiceMode = useCallback(() => {
    handleChooseChatMode("voice");
  }, [handleChooseChatMode]);

  const handleChooseTextMode = useCallback(() => {
    handleChooseChatMode("text");
  }, [handleChooseChatMode]);

  const handleWidgetIconClick = useCallback(() => {
    setStep(0);
  }, [setStep]);

  return (
    <div className="absolute right-[46px] bottom-[46px] flex flex-col gap-[10px] items-end [@media(max-width:440px)]:right-[10px] [@media(max-width:440px)]:bottom-[10px] [@media(max-width:440px)]:w-[calc(100%-20px)]">
      <div className="w-[273px] h-[246px] bg-white rounded-[30px] rounded-br-[0px] border border-gray-200 p-[20px] flex flex-col gap-[20px]">
        <p className="widget-title font-medium text-[22px] leading-[150%] tracking-[0%] text-center">
          Hey!
          <br />
          Let AI help you shop!
        </p>
        <div className="flex flex-col gap-[16px]">
          <button
            onClick={handleChooseVoiceMode}
            className="cursor-pointer voice-chat_button inline-block w-[100%] text-center pt-[14px] pb-[14px] rounded-[1022px] text-white"
          >
            Voice Chat
          </button>
          <div className="text-chat_wrapper w-[100%] p-[1px] rounded-[1022px] flex items-center content-center">
            <button
              onClick={handleChooseTextMode}
              className="cursor-pointer text-chat_button inline-block w-[100%] h-[100%] text-center pt-[14px] pb-[14px] rounded-[1022px] bg-white"
            >
              Text Chat
            </button>
          </div>
        </div>
      </div>
      <div className="gradient-wrap w-[58px] h-[57px] bg-white rounded-[50%] p-[2.5px]">
        <button
          onClick={handleWidgetIconClick}
          className="content cursor-pointer flex items-center justify-center"
        >
          <img
            src={widgetIcon}
            alt="widget-icon"
            className="w-[30px] h-[29px]"
          />
        </button>
      </div>
    </div>
  );
};

export default Step1;
